import React from 'react';

import { withStyles } from '@material-ui/styles';
import styles from './styles';
import { muiTheme } from '../../theme';
import Hidden from '@material-ui/core/Hidden';

import AppName from './AppName';
import Navbar from './Navbar';
import PersistentDrawerLeft from './Drawer';
import AppDropdown from './AppDropdown';
import role from '../../constants/role';

const Header = ({ appName, navigation, learningResources, user, classes }) => {
  const isBP = () => {
    const { userTeams = [] } = user || {};
    return userTeams.some(value => value === role.BP);
  };

  return (
    <header className={classes.root}>
      {!!navigation && !isBP() && (
        <Hidden className={classes.drawerHidden} smUp implementation="css">
          <PersistentDrawerLeft user={user} />
        </Hidden>
      )}
      <AppName {...appName} />
      {!!navigation && !isBP() && (
        <Hidden className={classes.navBarHidden} xsDown implementation="css">
          <Navbar user={user} {...navigation} />
        </Hidden>
      )}
      <AppDropdown user={user} learningResources={learningResources} />
    </header>
  );
};

export default withStyles(styles(muiTheme))(Header);
